<template>
  <div class="contractmanage">
    <el-card class="box-card">
      <div slot="header">
        <span class="ft20 D1D1D1">合同管理</span>
      </div>
      <div class="flex justify_content_between">
        <div class="flex justify_content_between navtit">
          <el-select
            size="small"
            v-model="contractType"
            clearable
            placeholder="合同类型"
            @change="selectChange"
          >
            <el-option
              v-for="item in contractTypes"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            >
            </el-option>
          </el-select>
          <el-input
            class="ml20"
            size="small"
            v-model="contractYear"
            @input="conYearVal"
            clearable
            placeholder="请输入合同年度"
          >
          </el-input>
          <el-input
            class="ml20"
            size="small"
            v-model="contractCode"
            @input="conCodeVal"
            clearable
            placeholder="请输入合同编码"
          >
          </el-input>
        </div>
        <div>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-refresh-right"
            @click="queryClick"
            >查询</el-button
          >
          <el-button
            size="small"
            type="primary"
            plain
            icon="el-icon-refresh-right"
            @click="resetClick"
            >重置</el-button
          >
        </div>
      </div>
      <div class="text item announcementview_content mt20">
        <el-table
          element-loading-spinner="el-icon-loading"
          v-loading="loading"
          :header-cell-style="{ textAlign: 'center',fontSize:'13px',color:'#787878',background:'#F5F5F5'}"
          :cell-style="{textAlign:'center',fontSize:'14px',color:'#1D1D1D'}"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="contractType"
            label="合同类型"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="contractYear" label="合同年度">
          </el-table-column>
          <el-table-column prop="contractCode" width="200px" label="合同编码">
          </el-table-column>
          <el-table-column prop="cusCode" label="客户编码"> </el-table-column>
          <el-table-column prop="cusName" label="客户名称"> </el-table-column>
          <el-table-column
            prop="confirmStatus"
            label="签订状态"
          ></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row)"
                type="text"
                size="small"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pageschange">
        <el-pagination
          background
          layout="total,prev, pager, next"
          :total="count"
          :page-size="pageSize"
          :current-page="pageNum"
          prev-text="上一页"
          next-text="下一页"
          @current-change="getList()"
        >
          <!-- v-bind="{ total: this.count, 'page-size': 10 }"
          @next-click="nextClick"
          @prev-click="prevClick"
          :current-page="currentPage" -->
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
/**
 *   @Author : 丁江
 *   @Date : 2021/3/30
 *   @Version : 1.0.0
 *   @Last Modified by : 丁江
 *   @Last Modified time : 2021/3/30
 *   @desc 合同管理
 **/
import { ContractManager, QueryContract } from "@/api/api";
export default {
  data() {
    return {
      //下拉框数据
      contractType: "",
      contractTypes: [],
      contractYear: "",
      contractCode: "",
      tableData: [], //   table 数据
      param: {}, //请求数据的参数，用的地方多， 存一个
      // currentPage: 1, //分页器当前页数
      count:0,
      pageNum: 1,
      pageSize:10,
      loading:true
    };
  },
  methods: {
    //下拉框事件
    selectChange(val) {
      this.contractType = val;
    },
    //合同年度输入框
    conYearVal(val) {
      this.contractYear = val;
    },
    //合同编码输入框
    conCodeVal(val) {
      this.contractCode = val;
    },
    //获取列表信息
    getList(param) {
      this.tableData = null;
      ContractManager(param)
        .then((res) => {
          let { data } = res.result;
          let arr = data.map((item) => {
            let obj = {};
            switch (item.contractType) {
              case "1":
                item.contractType = "合作合同";
                break;
              case "2":
                item.contractType = "框架合同";
                break;
              case "3":
                item.contractType = "发货合同";
                break;
            }
            obj.contractType = item.contractType;
            obj.contractYear = item.yearly;
            obj.contractCode = item.code;
            obj.cusCode = item.cusCode;
            obj.cusName = item.cusName;
            obj.confirmStatus = item.signState == 1 ? "已确认" : "未确认";
            return obj;
          });
          this.tableData = arr;
          this.count = res.result.count || 0;
          this.loading = false
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //查询方法
    queryClick() {
      this.loading = true
      let contractType = this.contractType;
      let yearly = this.contractYear;
      let code = this.contractCode;
      let pageNum = this.pageNum;
      let pageSize = this.pageSize;
      let param = {
        contractType,
        yearly,
        code,
        pageNum,
        pageSize,
      };
      this.param = param;
      // this.currentPage = 1;
      this.getList(this.param);
    },
    //重置方法
    resetClick() {
      this.loading = true
      this.contractType = "";
      this.contractCode = "";
      this.contractYear = "";
      this.param = {
        pageNum: 1,
        pageSize: 10,
        contractType: "",
        yearly: "",
        code: "",
      };
      // this.currentPage = 1;
      this.getList(this.param);
    },
    // //分页器页数改变时
    // sizeChange(nextPageNum) {
    //   this.loading = true
    //   this.param.pageNum = nextPageNum;
    //   this.getList(this.param);
    // },
    // // 分页处理
    // nextClick(nextPageNum){
    //   this.loading = true
    //   this.param.pageNum = nextPageNum;
    //   this.getList(this.param);
    // },
    // prevClick(prevPageNum){
    //   this.loading = true
    //     this.param.pageNum = prevPageNum;
    //   this.getList(this.param);
    // },
    // currentClick(currentPageNum){
    //   this.loading = true
    //   this.param.pageNum = currentPageNum;
    //   this.getList(this.param);
    // },
    // 查看
    handleClick(row){
      this.$router.push({
        path:'/home/main/contractManageDet',
        query:{
          code:row.contractCode
        }
      })
    }
  },
  mounted() {
    this.param = {
      pageNum: this.pageNum,
      pageSize: this.pageSize,
      contractType: "",
      yearly: "",
      code: "",
    };
    this.getList(this.param);
    QueryContract({ dictTypeCode: "contract_type" }).then((res) => {
      this.contractTypes = res.result;
    });
  },
};
</script>
<style lang="scss" scoped>
.contractmanage{
  height: 100%;
  /deep/.el-card{
    height: 100%;
    /deep/.el-card__header {
    border-bottom: 0;
    padding: 20px 20px 0px 20px;
  }
  .el-select {
      width: 100%;
    }
  // 选择框图标
    /deep/.el-icon-arrow-up:before {
      content: "\e790";
    }
    /deep/.el-input__inner {
      border-radius: 2px;
      background: #f5f5f5;
    }
  /deep/ .el-range-editor.el-input__inner {
      width: 150px;
    }
    /deep/.el-range-input {
      background: #f5f5f5;
    }
    .pageschange{
      margin: 20px auto;
      text-align: center;
    }
  }
}
</style>
